export enum ConsultancyType {
  BUYER = 'BUYER',
  AUCTION = 'AUCTION',
}

export interface Consultancy {
  consultancyType: ConsultancyType,
  name: string,
  email?: string,
  phoneNumber: string,
  address: string,
  consent: boolean,
  source: string,
}
